import Component from './Stepper'

export default Component
